import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

import { ContentSharePreviewFragment } from 'api';
import ActionButtons from '../ActionButtons';

interface IProps {
  shareCount: number;
  previewInfo: ContentSharePreviewFragment;
}

const Heading: FC<IProps> = ({ previewInfo, shareCount }) => {
  const { t } = useTranslation();
  const { shortened_urls } = previewInfo;

  return (
    <Grid container justify="space-between" alignItems="center">
      <Grid item>
        <Typography color="inherit" variant="h4">
          {t('sharing:dialogTitle')}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <Typography>{t('content:xShare', { count: shareCount || 0 })}</Typography>
          </Grid>
          <Grid item>
            <ActionButtons shortenedUrls={shortened_urls} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Heading;
